import { buildQuery, requestJson } from "./apiClient";

export function listRoles() {
  return requestJson("/api/admin/roles");
}

export function getRole(roleCode) {
  return requestJson(`/api/admin/roles/${encodeURIComponent(roleCode)}`);
}

export function createRole(payload) {
  return requestJson("/api/admin/roles", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateRole(roleCode, payload) {
  return requestJson(`/api/admin/roles/${encodeURIComponent(roleCode)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function deleteRole(roleCode) {
  return requestJson(`/api/admin/roles/${encodeURIComponent(roleCode)}`, {
    method: "DELETE",
  });
}

export function listPermissions() {
  return requestJson("/api/admin/permissions");
}

export function replaceRolePermissions(roleCode, permissions) {
  return requestJson(`/api/admin/roles/${encodeURIComponent(roleCode)}/permissions`, {
    method: "PUT",
    body: JSON.stringify({ permissions }),
  });
}

export function addRolePermissions(roleCode, permissions) {
  return requestJson(`/api/admin/roles/${encodeURIComponent(roleCode)}/permissions`, {
    method: "POST",
    body: JSON.stringify({ permissions }),
  });
}

export function removeRolePermission(roleCode, permissionCode) {
  return requestJson(
    `/api/admin/roles/${encodeURIComponent(roleCode)}/permissions/${encodeURIComponent(permissionCode)}`,
    { method: "DELETE" }
  );
}
